@if (shouldShow()) {
  <div class="trial-banner" role="status" [attr.data-severity]="severity()">
    <span class="trial-banner-text">
      @if (showsCountdown()) {
        <span class="trial-banner-line">
          @if (canManageBilling()) {
            @switch (severity()) {
              @case ('lastDay') { {{ 'billing.trialBanner.lastDay' | translate }} }
              @case ('urgent') { {{ tier.trialDaysRemaining() | l10nPlural: 'billing.trialBanner.urgent' }} }
              @case ('warning') { {{ tier.trialDaysRemaining() | l10nPlural: 'billing.trialBanner.warning' }} }
              @default { {{ tier.trialDaysRemaining() | l10nPlural: 'billing.trialBanner.info' }} }
            }
          } @else {
            @switch (severity()) {
              @case ('lastDay') { {{ 'billing.trialBanner.endsToday' | translate }} }
              @case ('info') { {{ tier.trialDaysRemaining() | l10nPlural: 'billing.trialBanner.info' }} }
              @default { {{ tier.trialDaysRemaining() | l10nPlural: 'billing.trialBanner.endsInDays' }} }
            }
          }
        </span>
      }
      @if (showsDeferredImages()) {
        <span class="trial-banner-line">{{ (canManageBilling() ? 'billing.trialBanner.deferredImages' : 'billing.trialBanner.deferredImagesPlain') | translate }}</span>
      }
    </span>
    @if (canManageBilling()) {
      <a routerLink="/admin/settings/plan-usage" class="trial-banner-cta">
        {{ 'billing.viewPlans' | translate }}
      </a>
    }
  </div>
}
